import React from 'react';
import classNames from 'classnames/bind';
import { RollingBanner } from '@techminds/ad-banner';

import ShareButton, {
  EventKey,
} from '@flight-workspace/common-client/src/components/shareButton';
import ZzimButton from 'common/zzimButton';
import DetailFooterDesc from './detailFooterDesc';
import config from 'config/index';
import { IFareDetail } from 'list/international/types';
import { areaCode } from './utils';

import SelectAgentBar from './selectAgentBar';

import styles from './index.module.scss';

const cx = classNames.bind(styles);

interface DetailWrapperProps {
  selectedFares?: IFareDetail[];
  favoriteItem?: any;
  modal?: React.ReactNode;
  children?: React.ReactNode;
}

const adUnitIds = [
  'tm_travel_flight_detail_mid_rolling_image_banner_0',
  'tm_travel_flight_detail_mid_rolling_image_banner_1',
  'tm_travel_flight_detail_mid_rolling_image_banner_2',
  'tm_travel_flight_detail_mid_rolling_image_banner_3',
  'tm_travel_flight_detail_mid_rolling_image_banner_4',
  'tm_travel_flight_detail_mid_rolling_image_banner_5',
  'tm_travel_flight_detail_mid_rolling_image_banner_6',
  'tm_travel_flight_detail_mid_rolling_image_banner_7',
  'tm_travel_flight_detail_mid_rolling_image_banner_8',
  'tm_travel_flight_detail_mid_rolling_image_banner_9',
].slice(0, config.maxRollingBannerCount);

const DetailWrapper: React.FC<DetailWrapperProps> = ({
  selectedFares,
  favoriteItem,
  modal,
  children,
}) => {
  return (
    <div className={cx('Detail')}>
      <section>
        <SelectAgentBar />
        <div className={cx('results')}>
          <div className={cx('Detail_agents')}>
            <div className={cx('inner')}>
              <div className={cx('promotion')}>
                <RollingBanner adUnitIds={adUnitIds} />
              </div>
              {children}
              <div className={cx('btns')}>
                {selectedFares && selectedFares.length > 0 && favoriteItem && (
                  <ZzimButton
                    areaCode={areaCode}
                    flightData={favoriteItem.flightData}
                    groupParam={favoriteItem.groupParam}
                  />
                )}
                <ShareButton
                  className="share naver-splugin"
                  evKey={EventKey.FLIGHT}
                  clickCode="idt.share"
                  serviceName="설레는 여행의 시작. 네이버 항공권과 함께!"
                  sourceName="네이버 항공권"
                  title="네이버 항공권"
                >
                  공유
                </ShareButton>
              </div>
            </div>
          </div>
        </div>
      </section>
      {modal}
      <DetailFooterDesc />
    </div>
  );
};

export default DetailWrapper;
